/**
 * Event View Switcher
 * Handles localStorage persistence for view preference
 */

document.addEventListener("turbo:load", function () {
  const viewSwitcher = document.querySelector(".event-view-switcher");
  if (!viewSwitcher) return;

  const currentView = new URLSearchParams(window.location.search).get("display") || "list";

  // Persist preference to localStorage
  if (currentView !== "list") {
    localStorage.setItem("eventDisplayView", currentView);
  } else {
    localStorage.removeItem("eventDisplayView");
  }

  // Optional: Restore preference on page load (if no display param in URL)
  if (!window.location.search.includes("display=")) {
    const savedView = localStorage.getItem("eventDisplayView");
    if (savedView && savedView !== "list") {
      const url = new URL(window.location);
      url.searchParams.set("display", savedView);
      // Don't auto-redirect, just note the preference for next time
    }
  }
});

